import React, { Component, Fragment } from "react";

export default class Login extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="content">
        <div className="container">
          <div className="col-lg-4 col-md-6 ml-auto mr-auto">

            <div className="card card-container">

              {/* <div className="card-header ">
                <div className="card-header ">
                  <h3 className="header text-center">Previsão das Metas 2023</h3>
                </div>
              </div> */}

              <div className="card-body ">
                <a href="http://2026.sigem.observatoriopb.com.br/login">
                  <button className="btn btn-primary btn-block">
                      <span>Elaboração 2026</span>
                  </button>
                </a>
                <a href="http://2025.sigem.observatoriopb.com.br/login">
                  <button className="btn btn-primary btn-block">
                      <span>2025</span>
                  </button>
                </a>
                <a href="http://2024.sigem.observatoriopb.com.br/login">
                  <button className="btn btn-primary btn-block">
                      <span>2024</span>
                  </button>
                </a>
                <a href="http://2023.sigem.observatoriopb.com.br/login">
                  <button className="btn btn-primary btn-block">
                      <span>2023</span>
                  </button>
                </a>
                <a href="http://2022.sigem.observatoriopb.com.br/login">
                  <button className="btn btn-primary btn-block">
                      <span>2022</span>
                  </button>
                </a>
              </div>

            </div>
          </div>

        </div>
      </div>
    );
  }

}
